// Original 16-bit pixel-art sprites rendered as SVG (transparent, crisp at any size)
const SPRITES = {
  coin: {
    palette: { g: "#FFB800", y: "#FFE38A", w: "#FFF7D6" },
    grid: [
      "...gggggg...",
      "..gggggggg..",
      ".ggyyyyyygg.",
      ".gyywwyyygg.",
      "ggywwgyyyygg",
      "ggywwgyyyygg",
      "ggyyyyyyyygg",
      "ggyyyyyyyygg",
      ".ggyyyyyygg.",
      "..gggggggg..",
      "...gggggg...",
    ],
  },
  heart: {
    palette: { r: "#FF2D55", w: "#FFD6DD" },
    grid: [
      "..rrr...rrr.",
      ".rrrrr.rrrrr",
      "rrwwrrrrrrrr",
      "rrwwrrrrrrrr",
      "rrrrrrrrrrrr",
      ".rrrrrrrrrr.",
      "..rrrrrrrr..",
      "...rrrrrr...",
      "....rrrr....",
      ".....rr.....",
    ],
  },
  star: {
    palette: { y: "#FFD93D", w: "#FFF6C9" },
    grid: [
      ".....yy.....",
      "....yyyy....",
      "....yyyy....",
      ".yyyyyyyyyy.",
      "yyyyyyyyyyyy",
      "yyyyyyyyyyyy",
      ".yyyyyyyyyy.",
      "..yyyyyyyy..",
      "..yyyy.yyyy.",
      "..yyy...yyy.",
    ],
  },
  ghost: {
    palette: { m: "#FF007A", w: "#FFFFFF", b: "#090A0F" },
    grid: [
      "....mmmm....",
      "..mmmmmmmm..",
      ".mmmmmmmmmm.",
      ".mmwwmmwwmm.",
      ".mmwbmmwbmm.",
      ".mmmmmmmmmm.",
      ".mmmmmmmmmm.",
      ".mmmmmmmmmm.",
      ".mmmmmmmmmm.",
      ".mmmmmmmmmm.",
      ".m.mm.mm.mm.",
    ],
  },
  sword: {
    palette: { c: "#00F0FF", w: "#E6FEFF", g: "#FFB800", b: "#8A5A2B" },
    grid: [
      ".....cc.....",
      "....cwcc....",
      "....cwcc....",
      "....cwcc....",
      "....cwcc....",
      "....cwcc....",
      "....cwcc....",
      "....cccc....",
      "..gggggggg..",
      ".....gg.....",
      ".....bb.....",
      "....bbbb....",
    ],
  },
  barrel: {
    palette: { b: "#8A5A2B", d: "#5E3A17", s: "#9AA4B2" },
    grid: [
      "...bbbbbb...",
      "..bbbbbbbb..",
      ".bddddddddb.",
      ".bbbbbbbbbb.",
      ".bbbbbbbbbb.",
      ".bssssssssb.",
      ".bbbbbbbbbb.",
      ".bbbbbbbbbb.",
      ".bssssssssb.",
      ".bbbbbbbbbb.",
      ".bddddddddb.",
      "..bbbbbbbb..",
      "...bbbbbb...",
    ],
  },
  pipe: {
    palette: { g: "#22C55E", l: "#86EFAC" },
    grid: [
      ".gggggggggg.",
      "gggggggggggg",
      "glllgggggggg",
      "glllgggggggg",
      "gggggggggggg",
      ".gggggggggg.",
      "..gggggggg..",
      "..glllgggg..",
      "..glllgggg..",
      "..glllgggg..",
      "..gggggggg..",
    ],
  },
};

export function PixelSprite({ name, size = 48, className = "", style }) {
  const s = SPRITES[name];
  if (!s) return null;
  const rows = s.grid.length;
  const cols = s.grid[0].length;
  const rects = [];
  s.grid.forEach((row, y) =>
    row.split("").forEach((ch, x) => {
      if (s.palette[ch]) {
        rects.push(<rect key={`${x}-${y}`} x={x} y={y} width={1.02} height={1.02} fill={s.palette[ch]} />);
      }
    })
  );
  return (
    <svg viewBox={`0 0 ${cols} ${rows}`} width={size} height={size} className={className}
      style={{ imageRendering: "pixelated", ...style }} aria-hidden="true">
      {rects}
    </svg>
  );
}

export function FloatingSprites() {
  return (
    <div className="pointer-events-none absolute inset-0 z-[5] overflow-hidden" aria-hidden="true" data-testid="floating-sprites">
      <PixelSprite name="coin" size={54} className="anim-bob absolute right-[10%] top-[16%] opacity-90" />
      <PixelSprite name="ghost" size={62} className="anim-drift absolute left-[5%] top-[36%] opacity-90" />
      <PixelSprite name="star" size={42} className="anim-bob-slow absolute right-[24%] top-[56%] opacity-90" style={{ animationDelay: "1.2s" }} />
      <PixelSprite name="sword" size={50} className="anim-bob absolute left-[15%] top-[68%] opacity-90" style={{ animationDelay: ".6s" }} />
      <PixelSprite name="heart" size={38} className="anim-drift absolute right-[38%] top-[12%] opacity-80" style={{ animationDelay: "2s" }} />
    </div>
  );
}

export function SpriteParade() {
  const order = ["ghost", "coin", "star", "barrel", "pipe", "heart", "sword"];
  const row = [...order, ...order, ...order, ...order];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-inkalt/70 py-4" data-testid="sprite-parade">
      <div className="flex w-max animate-marquee items-end gap-16">
        {row.map((n, i) => (
          <PixelSprite key={i} name={n} size={38} className="anim-bob" style={{ animationDelay: `${(i % 7) * 0.3}s` }} />
        ))}
      </div>
    </div>
  );
}
